module.exports = __webpack_public_path__ + "static/media/42.ff999704.jpg";